var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/usePrevious/index.ts
import { useEffect, useRef } from "react";
var usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

// src/useKeyPress/index.ts
import { useEffect as useEffect2 } from "react";
var keyValue = {
  Down: "ArrowDown",
  Up: "ArrowUp",
  Left: "ArrowLeft",
  Right: "ArrowRight",
  Esc: "Escape",
  Space: " "
};
var valueKey = Object.keys(keyValue).reduce((acc, key) => {
  acc[keyValue[key]] = key;
  return acc;
}, {});
var browserCompatKeys = __spreadValues(__spreadValues({}, keyValue), valueKey);
var useKeyPress = (keysToListenTo, callback) => useEffect2(() => {
  const keysToMatch = keysToListenTo.split(/[, ]/).map((key) => key.toLowerCase());
  const handleKeyDown = ({ key: rawKey }) => {
    var _a;
    if (!rawKey) {
      return;
    }
    if (keysToMatch.includes(rawKey.toLowerCase()) || keysToMatch.includes((_a = browserCompatKeys[rawKey]) == null ? void 0 : _a.toLowerCase())) {
      callback(rawKey);
    }
  };
  document.addEventListener("keydown", handleKeyDown, true);
  return () => document.removeEventListener("keydown", handleKeyDown, true);
}, [callback, keysToListenTo]);
export {
  useKeyPress,
  usePrevious
};
